<h1 anessaTranslation="PROJECT.FEEDSTOCK_LIST.FEEDSTOCK"></h1>
<div class="border-outline">
  <h3 class="outline-border-header" anessaTranslation="PROJECT.FEEDSTOCK_LIST.EXISTING_FEEDSTOCK"></h3>
  <div class="relative-container">
    <anessa-table
      [data]="feedstocks"
      [keys]="['name']"
      [customFields]="getNormalizedMassArray()"
      [translateCustomFields]="true"
      [customFieldsAreUnits]="true"
      (onEdit)="onEditClick($event)"
      (onRemove)="onDeleteClick($event)">
    </anessa-table>
  </div>
  <div class="table-row" *ngIf="totalFeedstock !== ''">
    <div class="table-cell flex-1" anessaTranslation="PROJECT.FEEDSTOCK_LIST.TOTAL">
    </div>
    <div class="flex-2 flex-container" style="justify-content: flex-end;">
      <div class="value-cell vertical-center">{{ totalFeedstock }} {{ totalUnit | anessaTranslation: trigger}}</div>
      <div class="button-cell" style="visibility: hidden;">
        <div class="edit"> <a anessaTranslation="HELPER.TABLE.EDIT"></a></div>
        <div class="remove"> <a anessaTranslation="HELPER.TABLE.REMOVE"></a></div>
      </div>
    </div>
  </div>
  <div class="wrapped-button-container">
    <button
      mat-button
      class="wrapped-button button-width"
      (click)="onAddClick()"
      anessaTranslation="PROJECT.FEEDSTOCK_LIST.ADD_FEED">
    </button>
  </div>
</div>
